<template>
  <article class="product-card">
    <header class="card-top">
      <span class="pill">{{ product.role }}</span>
      <div class="available" v-if="availableItems.length">
        <span v-for="(item, index) in availableItems" :key="index" class="badge">
          {{ item }}
        </span>
      </div>
    </header>

    <div class="visual">
      <img :src="product.image_url" :alt="product.name" class="product-image" />
    </div>

    <div class="card-body">
      <h3 class="title">{{ product.name }}</h3>
      <p class="subtitle">Garanti edilen içerik</p>
      <table class="icerik">
        <tr v-for="(value, key) in product.icerik" :key="key">
          <td class="icerik-key">{{ key }}</td>
          <td class="icerik-value">{{ value }}</td>
        </tr>
      </table>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ProductTile',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    availableItems() {
      return this.product.available ? this.product.available.split('-') : [];
    }
  }
};
</script>

<style scoped>
.product-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px;
  display: grid;
  gap: 10px;
  color: #0f172a;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pill {
  background: #ecfdf3;
  color: #166534;
  padding: 6px 10px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 12px;
}

.available {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.badge {
  background: #e0f2fe;
  color: #0ea5e9;
  border: 1px solid #bae6fd;
  border-radius: 10px;
  padding: 5px 8px;
  font-weight: 700;
  font-size: 12px;
}

.visual {
  background: radial-gradient(140% 140% at 50% 0%, #ecfdf3, #ffffff);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  display: grid;
  place-items: center;
}

.product-image {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.card-body {
  display: grid;
  gap: 8px;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
}

.subtitle {
  margin: 0;
  color: #334155;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
}

.icerik {
  width: 100%;
  border-collapse: collapse;
  color: #0f172a;
}

.icerik tr {
  border-bottom: 1px solid #e2e8f0;
}

.icerik tr:last-child {
  border-bottom: none;
}

.icerik-key {
  padding: 6px 6px 6px 0;
  font-weight: 700;
  text-align: left;
  color: #334155;
}

.icerik-value {
  padding: 6px 0;
  text-align: right;
  color: #0f172a;
}

@media (max-width: 640px) {
  .product-card {
    padding: 12px;
  }
}
</style>
